import { useTranslation } from "react-i18next";

interface PdfTranscriptionProps {
  transcription?: string;
  onRetry?: () => void;
}

const PdfTranscription = ({ transcription, onRetry }: PdfTranscriptionProps) => {
  const { t } = useTranslation();

  if (transcription) {
    return (
      <div className="my-4">
        <label htmlFor="transcription" className="block text-lg font-medium text-gray-700 mb-2">
          {t("pages.gallery.transcription")}
        </label>
        <textarea
          id="transcription"
          className="block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm resize-y"
          value={transcription}
          disabled
          rows={6}
          style={{ maxHeight: "300px", overflowY: "auto" }}
        />
      </div>
    );
  }

  return (
    <div className="my-4">
      <p className="text-sm text-gray-500 italic mb-2">
        {t("pages.gallery.noTranscriptionAvailable")}
      </p>
      <button type="button" className="btn-alternative-outline text-sm" onClick={onRetry}>
        {t("pages.gallery.retryTranscription")}
      </button>
    </div>
  );
};

export default PdfTranscription;
